export default function OutlinedCaretDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="2.4rem" height="2.4rem" viewBox="0 0 24 24" {...props}>
      <path d="M17 10L12 15L7 10H17Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  );
}
